<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M19.587 18.161a8.737 8.737 0 10-1.426 1.426l8.118 8.118a1.008 1.008 0 101.426-1.426l-8.118-8.118zm-6.85-9.456c-.557 0-1.008.451-1.008 1.008v2.016H9.713a1.008 1.008 0 100 2.016h2.016v2.017a1.008 1.008 0 002.016 0v-2.017h2.017a1.008 1.008 0 000-2.016h-2.017V9.713c0-.557-.451-1.008-1.008-1.008z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsZoomInFilled'
}
</script>
